import React from "react";
import "./PageHeroBanner.css";

function PageHeroBanner({ heading, image, eyebrow, description, className = "" }) {
  return (
    <div
      className={`page-hero-banner ${className}`.trim()}
      style={{ backgroundImage: image ? `url(${image})` : undefined }}
    >
      <div className="page-hero-banner-overlay" />
      <div className="page-hero-banner-content">
        {eyebrow && <p className="page-hero-banner-eyebrow">{eyebrow}</p>}
        <p className="page-hero-banner-text">{heading}</p>
        {description && <p className="page-hero-banner-description">{description}</p>}
      </div>
    </div>
  );
}

export default PageHeroBanner;
